import Head from 'next/head';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import { APPLICATION_LINK, APPLICATION_TITLE } from '@/Module/Core/Constant';
import { replaceHalfSpace } from '@/Module/Core/Helper';
import { useAppSelector } from '@/Module/Store/Hook';
import TeacherListBreadcrumb from './TeacherListBreadcrumb';
import TeacherListHeader from './TeacherListHeader';
import TeacherListByCategory from './TeacherRowByCategory';
const TeacherListContainer: FC = () => {
  const router = useRouter();
  const ids = useAppSelector(state => state.teacherCategory.ids);
  const pageTitle = 'معلم های آی‌نو - لیست معلمین برتر پایه پنجم تا دوازدهم';
  const pageDescription = 'معلم های آی‌نو – در صفحه معلمین اسامی تمامی معلمین برتر پایه های پنجم تا دوازدهم به همراه سوابق تحصیلی، رزومه کاری و دستاوردهای علمی هریک از آنها موجود است.';
  const pageUrl = `${APPLICATION_LINK}${router.asPath}`;
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="TeacherListContainer.tsx">
        <title>{replaceHalfSpace(pageTitle)}</title>
        <meta name="description" content={replaceHalfSpace(pageDescription)} data-sentry-element="meta" data-sentry-source-file="TeacherListContainer.tsx" />
        <link rel="canonical" href={pageUrl} />
        <meta property="og:locale" content="fa_IR" data-sentry-element="meta" data-sentry-source-file="TeacherListContainer.tsx" />
        <meta property="og:type" content="article" data-sentry-element="meta" data-sentry-source-file="TeacherListContainer.tsx" />
        <meta property="og:title" content={pageTitle} data-sentry-element="meta" data-sentry-source-file="TeacherListContainer.tsx" />
        <meta property="og:description" content={replaceHalfSpace(pageDescription)} data-sentry-element="meta" data-sentry-source-file="TeacherListContainer.tsx" />
        <meta property="og:url" content={pageUrl} data-sentry-element="meta" data-sentry-source-file="TeacherListContainer.tsx" />
        <meta property="og:site_name" content={replaceHalfSpace(APPLICATION_TITLE)} data-sentry-element="meta" data-sentry-source-file="TeacherListContainer.tsx" />
        <meta name="twitter:card" content="summary_large_image" data-sentry-element="meta" data-sentry-source-file="TeacherListContainer.tsx" />
        <meta name="twitter:title" content={pageTitle} data-sentry-element="meta" data-sentry-source-file="TeacherListContainer.tsx" />
        <meta name="twitter:description" content={replaceHalfSpace(pageDescription)} data-sentry-element="meta" data-sentry-source-file="TeacherListContainer.tsx" />
      </Head>
      <TeacherListBreadcrumb data-sentry-element="TeacherListBreadcrumb" data-sentry-source-file="TeacherListContainer.tsx" />
      <TeacherListHeader data-sentry-element="TeacherListHeader" data-sentry-source-file="TeacherListContainer.tsx" />
      {ids.map(id => <div key={id} className="flex odd:bg-teacher-list-Light">
          <TeacherListByCategory id={id} />
        </div>)}
    </>;
};
export default TeacherListContainer;